import { render, staticRenderFns } from "./jak-kupic-akcje-ebay.md?vue&type=template&id=c0d2e1b0&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports